import { render, staticRenderFns } from "./foreign-base-radio.vue?vue&type=template&id=1e8a70f0&scoped=true"
import script from "./foreign-base-radio.vue?vue&type=script&lang=js"
export * from "./foreign-base-radio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8a70f0",
  null
  
)

export default component.exports